import React, { useState ,useEffect  } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../Navbar/Navbar'; // Assuming Navbar is in this location
import './PatientLogin.css'; // Import the new CSS file
    const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; // Your backend API URL
const RESEND_COOLDOWN_SECONDS = 30;

const PatientLogin = () => {
    const navigate = useNavigate();
    const { doctorId } = useParams();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        age: '',
        address: '',
    });
    const [message, setMessage] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isRegisteredUser, setIsRegisteredUser] = useState(false);
    const [isLoginMode, setIsLoginMode] = useState(true); // Default to Login mode
    const [otp, setOtp] = useState('');
    const [showModal, setShowModal] = useState(false);
 const [resendCooldown, setResendCooldown] = useState(0);
    const [timerId, setTimerId] = useState(null);

    useEffect(() => {
        return () => {
            if (timerId) {
                clearInterval(timerId);
            }
        };
    }, [timerId]);


    // --- ADDED: Function to start the resend cooldown timer ---
    const startResendTimer = () => {
        // Clear any existing timer before starting a new one
        if (timerId) {
            clearInterval(timerId);
        }

        setResendCooldown(RESEND_COOLDOWN_SECONDS);
        
        const newTimerId = setInterval(() => {
            setResendCooldown(prevCooldown => {
                if (prevCooldown <= 1) {
                    clearInterval(newTimerId);
                    return 0; // Stop the countdown
                }
                return prevCooldown - 1;
            });
        }, 1000);
        setTimerId(newTimerId);
    };
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            // Allow only digits and limit to 10 characters for phone number
            const numericValue = value.replace(/[^0-9]/g, '');
            setFormData({ ...formData, [name]: numericValue.slice(0, 10) });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleOtpChange = (e) => {
        // Allow only digits and limit to 6 characters for OTP
        const numericValue = e.target.value.replace(/[^0-9]/g, '');
        setOtp(numericValue.slice(0, 6));
    };

    const handleAuth = async () => {
        if (!formData.phone || formData.phone.length !== 10) {
            setMessage("Please enter a valid 10-digit phone number.");
            return;
        }
        setMessage(''); // Clear previous messages

        try {
            const checkUserResponse = await axios.post(`${API_BASE_URL}/check-user`, {
                phone: formData.phone,
            });
            const userExistsInDb = checkUserResponse.data.exists;

            if (userExistsInDb) {
                if (!isLoginMode) { // Trying to register an existing number
                    setMessage("Mobile number already registered. Please switch to Login mode.");
                    alert("Mobile number already registered. Please switch to Login mode.");
                    return;
                }
                // Proceeding with Login
                setIsRegisteredUser(true);
                setMessage("User found! Sending OTP for login...");
            } else { // User does not exist in DB
                if (isLoginMode) { // Trying to login a non-existent number
                    setMessage("This phone number is not registered. Please switch to Register mode.");
                    alert("This phone number is not registered. Please switch to Register mode.");
                    return;
                }
                // Proceeding with registration: validate required fields
                if (!formData.firstName || !formData.lastName || !formData.age || !formData.address) {
                    setMessage("First Name, Last Name, Age, and Address are required for registration.");
                    alert("First Name, Last Name, Age, and Address are required for registration.");
                    return;
                }
                setIsRegisteredUser(false);
                setMessage("New user! Sending OTP for registration...");
            }

            const otpRequestResponse = await axios.post(`${API_BASE_URL}/request-otp`, {
                mobile: formData.phone,
            });

            if (otpRequestResponse.status === 200) {
                setIsOtpSent(true);
                setMessage("OTP sent successfully! Check your phone.");
                setShowModal(true);
                  startResendTimer();
            } else {
                setMessage(otpRequestResponse.data.message || "Failed to send OTP. Please try again.");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Error during authentication process.";
            setMessage(errorMessage);
            console.error("[PatientLogin.js] Error in handleAuth:", error);
        }
    };
 const handleResendOtp = async () => {
        if (resendCooldown > 0) {
            return; // Do nothing if cooldown is active
        }

        setMessage("Resending OTP...");
        try {
            // Call the same endpoint to get a new OTP
            const resendResponse = await axios.post(`${API_BASE_URL}/api/send-otp`, {
                mobile: formData.phone,
            });

            if (resendResponse.status === 200) {
                setMessage("New OTP sent successfully!");
                setOtp(''); // Clear old OTP from input
                startResendTimer(); // Restart the cooldown timer
            } else {
                setMessage(resendResponse.data.message || "Failed to resend OTP.");
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to resend OTP. Please try again later.";
            setMessage(errorMessage);
            console.error("[PatientLogin.js] Error in handleResendOtp:", error);
        }
    };
    const verifyOtp = async () => {
        if (!otp || otp.length !== 6) {
            setMessage("Please enter the 6-digit OTP.");
            return;
        }
        setMessage(''); // Clear previous messages

        try {
            const otpVerifyResponse = await axios.post(`${API_BASE_URL}/verify-otp`, {
                mobile: formData.phone,
                otp,
            });

            if (otpVerifyResponse.status === 200) {
                setMessage("OTP verified successfully!");
                let finalPatientId;

                    if (!isRegisteredUser) { // This means it was a registration flow
                    try {
                        // Attempt to register the user
                        const registerResponse = await axios.post(`${API_BASE_URL}/register`, formData);

                        // If the /register call itself was successful (didn't throw an error),
                        // we consider the registration attempt successful enough to send an SMS.
                        console.log("[PatientLogin.js] Registration API call successful. Response data:", registerResponse.data);

                        // --- SEND REGISTRATION SUCCESS SMS ---
                        // This will now run as long as the '/register' call didn't error out,
                        // regardless of whether patientId is in the response.
                        try {
                            let patientNameForSms = '';
                            if (formData.firstName && formData.lastName) {
                                patientNameForSms = `${formData.firstName} ${formData.lastName}`;
                            } else if (formData.firstName) {
                                patientNameForSms = formData.firstName;
                            }
                            
                            console.log("[PatientLogin.js] Attempting to send registration success SMS to:", formData.phone);
                            await axios.post(`${API_BASE_URL}/api/send-registration-success-sms`, {
                                mobile: formData.phone,
                                patientName: patientNameForSms
                            });
                            console.log("[PatientLogin.js] Registration success SMS request sent successfully.");
                        } catch (smsError) {
                            console.error("[PatientLogin.js] Error sending registration success SMS (non-blocking):", 
                                smsError.response ? smsError.response.data : smsError.message);
                            // Do not block the main flow, just log the error.
                        }
                        // --- END: Send Registration Success SMS ---

                        // Now, check if patientId was returned
                        if (registerResponse.data && registerResponse.data.patientId) {
                            finalPatientId = registerResponse.data.patientId;
                            console.log("[PatientLogin.js] New user registered. Patient ID:", finalPatientId);
                            // setMessage("Registration successful! Proceeding..."); // Optional: update message
                        } else {
                            // Registration API call was successful, SMS sent, but no patientId returned.
                            setMessage("Registration successful! Please Login to continue.");
                            console.warn("[PatientLogin.js] Registration successful (SMS sent), but patient ID was not returned by /register. User should login manually. Response data:", registerResponse.data);
                            setShowModal(false); // Close OTP modal
                            return; // Exit verifyOtp, as we cannot proceed without patientId
                        }
                    } catch (registerError) {
                        const errorMessage = registerError.response?.data?.message || registerError.message;
                        setMessage("Error during user registration: " + errorMessage);
                        console.error("[PatientLogin.js] Error during user registration:", registerError);
                        return;
                    }
                } else { // This means it was a login flow for an existing user
                    try {
                        // We need to fetch the patientId for the existing user based on phone
                        const patientsResponse = await axios.get(`${API_BASE_URL}/patients/`); // Assuming this endpoint exists
                        const allPatients = patientsResponse.data;

                        if (!Array.isArray(allPatients)) {
                            setMessage("Error: Could not retrieve patient list correctly.");
                            console.error("[PatientLogin.js] Expected an array from /patients, got:", allPatients);
                            return;
                        }
                        
                        const loggedInPatient = allPatients.find(
                            (patient) => patient.phone === formData.phone
                        );

                        if (loggedInPatient && loggedInPatient.patientId) {
                            finalPatientId = loggedInPatient.patientId;
                            console.log("[PatientLogin.js] Existing user logged in. Patient ID:", finalPatientId);

                            // --- ADDED: Send Login Success SMS ---
                            try {
                                let patientNameForSms = '';
                                if (loggedInPatient.firstName && loggedInPatient.lastName) {
                                    patientNameForSms = `${loggedInPatient.firstName} ${loggedInPatient.lastName}`;
                                } else if (loggedInPatient.firstName) {
                                    patientNameForSms = loggedInPatient.firstName;
                                }
                                // If name parts are not found, patientNameForSms remains '', 
                                // and backend should handle it (e.g., use 'User').

                                console.log("[PatientLogin.js] Attempting to send login success SMS to:", formData.phone);
                                await axios.post(`${API_BASE_URL}/api/send-login-success-sms`, {
                                    mobile: formData.phone,
                                    patientName: patientNameForSms
                                });
                                console.log("[PatientLogin.js] Login success SMS request sent successfully.");
                            } catch (smsError) {
                                console.error("[PatientLogin.js] Error sending login success SMS:", 
                                    smsError.response ? smsError.response.data : smsError.message);
                                // Do not block the main flow, just log the error.
                            }
                            // --- END: Send Login Success SMS ---

                        } else {
                            // --- START: Send Registration Success SMS ---
                            try {
                                let patientNameForSms = '';
                                if (formData.firstName && formData.lastName) {
                                    patientNameForSms = `${formData.firstName} ${formData.lastName}`;
                                } else if (formData.firstName) {
                                    patientNameForSms = formData.firstName;
                                }
                                // If name parts are not found, patientNameForSms remains '',
                                // and your backend endpoint /api/send-registration-success-sms
                                // should handle this (e.g., use 'User' as a default).
                                
                                console.log("[PatientLogin.js] Attempting to send registration success SMS to:", formData.phone);
                                await axios.post(`${API_BASE_URL}/api/send-registration-success-sms`, {
                                    mobile: formData.phone,
                                    patientName: patientNameForSms // This uses the name entered during registration
                                });
                                console.log("[PatientLogin.js] Registration success SMS request sent successfully.");
                            } catch (smsError) {
                                console.error("[PatientLogin.js] Error sending registration success SMS:", 
                                    smsError.response ? smsError.response.data : smsError.message);
                                // Do not block the main flow, just log the error.
                            }
                            // --- END: Send Registration Success SMS ---
                             // This case might occur if /check-user said exists but /patients doesn't find it,
                             // or if patient data is somehow incomplete.
                            setMessage("successfully Registered , Login Now.");
                            console.error(
                                "successfully Registered , Login Now.", formData.phone,
                                "Patient found:", loggedInPatient,
                                "All patients:", allPatients.length > 10 ? `Array of ${allPatients.length} patients` : allPatients
                            );
                            return;
                        }
                    } catch (fetchError) {
                        const errorMessage = fetchError.response?.data?.message || fetchError.message;
                        setMessage("Error fetching patient details after login: " + errorMessage);
                        console.error(" Error fetching patient details:", fetchError);
                        return;
                    }
                }

                if (finalPatientId) {
                    if (doctorId) {
                        console.log(` Navigating to booking page for doctor ${doctorId} with patientId ${finalPatientId}. State object:`, { patientId: finalPatientId });
                        navigate(`/booking/${doctorId}`, { state: { patientId: finalPatientId } });
                        setShowModal(false);
                    } else {
                        setMessage("Doctor ID is missing. Cannot proceed to booking page.");
                        console.error(" Doctor ID is missing. Cannot proceed to booking page.");
                    }
                } else {
                    // This message implies finalPatientId was not set, which should have been caught earlier
                    setMessage("A critical error occurred: Patient ID could not be determined after OTP verification.");
                    console.error(" Patient ID (finalPatientId) is undefined before navigation attempt.");
                }

            } else {
                setMessage(otpVerifyResponse.data.message || "Invalid OTP or an unexpected server response during OTP verification.");
            }
        } catch (error) {
            let errorMessage = "Error verifying OTP.";
            if (error.response) {
                errorMessage = error.response.data.message || error.response.statusText || `Server error (${error.response.status})`;
                console.error(" Error verifying OTP - Server Response:", error.response.data || error.response.status);
            } else if (error.request) {
                errorMessage = "No response from OTP verification server. Please check your network connection.";
                console.error(" Error verifying OTP - No response from server:", error.request);
            } else {
                errorMessage = error.message;
                console.error(" Error verifying OTP - Request setup or general error:", error.message);
            }
            setMessage(errorMessage);
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setIsOtpSent(false); 
        setMessage(''); 
        setOtp(''); 
    };

    const toggleMode = () => {
        setIsLoginMode(!isLoginMode);
        setMessage('');
        // Clear form data when switching modes, except phone if you want to keep it
        // For simplicity, clearing all relevant fields
        setFormData({
            firstName: '',
            lastName: '',
            email: '',
            phone: isLoginMode ? formData.phone : '', // Keep phone if switching from login to reg, or clear if switching from reg to login
            age: '',
            address: '',
        });
        setOtp('');
        setIsOtpSent(false);
    };


    // --- JSX ---
    return (
        <div className="patientlogin-page-container">
            <header className="patientlogin-header">
                <Navbar />
            </header>

            <div className="patientlogin-breadcrumb-wrapper">
                <div className="patientlogin-breadcrumb-container">
                    <nav aria-label="breadcrumb" className="patientlogin-breadcrumb-nav">
                        <ol className="patientlogin-breadcrumb-list">
                            <li className="patientlogin-breadcrumb-item"><a href="/">Home</a></li>
                            <li className="patientlogin-breadcrumb-item patientlogin-breadcrumb-item-active" aria-current="page">Patient Access</li>
                        </ol>
                    </nav>
                    <h1 className="patientlogin-page-title">Patient Authentication</h1>
                </div>
            </div>

            <main className="patientlogin-main-content">
                <div className="patientlogin-form-container">
                    <div className="patientlogin-form-card">
                        <div className="patientlogin-form-card-body">
                            <form className="patientlogin-auth-form" onSubmit={(e) => e.preventDefault()}>
                                <h2 className="patientlogin-form-greeting">Welcome, Patient!</h2>
                                <h3 className="patientlogin-form-mode-title">{isLoginMode ? 'Login with Mobile OTP' : 'Register with Mobile OTP'}</h3>
                                
                                {message && !showModal && ( 
                                    <p className={`patientlogin-message ${
                                        message.toLowerCase().includes("error") || 
                                        message.toLowerCase().includes("failed") || 
                                        message.toLowerCase().includes("invalid") ||
                                        message.toLowerCase().includes("not registered") ||
                                        message.toLowerCase().includes("already registered") ||
                                        message.toLowerCase().includes("missing") ||
                                        message.toLowerCase().includes("enter a valid 10-digit")
                                        ? 'patientlogin-message-error' : 'patientlogin-message-success'}`
                                    }>{message}</p>
                                )}

                                {!isOtpSent && (
                                    <>
                                        {/* Login Mode Fields */}
                                        {isLoginMode && (
                                             <div className="patientlogin-form-group">
                                                <label htmlFor="patientlogin-phone-login" className="patientlogin-form-label">Phone Number *</label>
                                                <input 
                                                    id="patientlogin-phone-login" 
                                                    type="tel" 
                                                    name="phone" 
                                                    placeholder="Enter your 10-digit mobile number" 
                                                    value={formData.phone} 
                                                    onChange={handleChange} 
                                                    className="patientlogin-form-input" 
                                                    required 
                                                    pattern="[0-9]{10}" // HTML5 validation for 10 digits
                                                    maxLength="10" // Restrict input length
                                                    title="Please enter a valid 10-digit mobile number"/>
                                            </div>
                                        )}

                                        {/* Registration Mode Fields */}
                                        {!isLoginMode && (
                                            <>
                                                <div className="patientlogin-form-row">
                                                    <div className="patientlogin-form-group patientlogin-form-group-half">
                                                        <label htmlFor="patientlogin-firstName" className="patientlogin-form-label">First Name *</label>
                                                        <input id="patientlogin-firstName" type="text" name="firstName" placeholder="Your First Name" value={formData.firstName} onChange={handleChange} className="patientlogin-form-input" required={!isLoginMode}/>
                                                    </div>
                                                    <div className="patientlogin-form-group patientlogin-form-group-half">
                                                        <label htmlFor="patientlogin-lastName" className="patientlogin-form-label">Last Name *</label>
                                                        <input id="patientlogin-lastName" type="text" name="lastName" placeholder="Your Last Name" value={formData.lastName} onChange={handleChange} className="patientlogin-form-input" required={!isLoginMode}/>
                                                    </div>
                                                </div>
                                                <div className="patientlogin-form-group">
                                                    <label htmlFor="patientlogin-email" className="patientlogin-form-label">Email</label>
                                                    <input id="patientlogin-email" type="email" name="email" placeholder="your.email@example.com (Optional)" value={formData.email} onChange={handleChange} className="patientlogin-form-input"/>
                                                </div>
                                                <div className="patientlogin-form-row">
                                                    <div className="patientlogin-form-group patientlogin-form-group-half">
                                                        <label htmlFor="patientlogin-age" className="patientlogin-form-label">Age *</label>
                                                        <input id="patientlogin-age" type="number" name="age" placeholder="Your Age" value={formData.age} onChange={handleChange} className="patientlogin-form-input" required={!isLoginMode}/>
                                                    </div>
                                                     <div className="patientlogin-form-group patientlogin-form-group-half">
                                                        <label htmlFor="patientlogin-phone-register" className="patientlogin-form-label">Phone Number *</label>
                                                        <input 
                                                            id="patientlogin-phone-register" 
                                                            type="tel" 
                                                            name="phone" 
                                                            placeholder="10-digit mobile" 
                                                            value={formData.phone} 
                                                            onChange={handleChange} 
                                                            className="patientlogin-form-input" 
                                                            required 
                                                            pattern="[0-9]{10}" // HTML5 validation for 10 digits
                                                            maxLength="10" // Restrict input length
                                                            title="Please enter a valid 10-digit mobile number"/>
                                                    </div>
                                                </div>
                                                <div className="patientlogin-form-group">
                                                    <label htmlFor="patientlogin-address" className="patientlogin-form-label">Address *</label>
                                                    <input id="patientlogin-address" type="text" name="address" placeholder="Your Full Address" value={formData.address} onChange={handleChange} className="patientlogin-form-input" required={!isLoginMode}/>
                                                </div>
                                            </>
                                        )}
                                    
                                        <div className="patientlogin-action-section">
                                            <button className="patientlogin-submit-btn" onClick={handleAuth} type='button'>
                                                {isLoginMode ? 'Send OTP to Login' : 'Send OTP to Register'}
                                            </button>
                                        </div>
                                        <button 
                                            onClick={toggleMode} 
                                            type='button' className="patientlogin-toggle-mode-btn"
                                        >
                                            {isLoginMode ? 'New user? Register here' : 'Already registered? Login here'}
                                        </button>
                                    </>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </main>

            {showModal && (
                <div className={`patientlogin-otp-modal ${showModal ? 'patientlogin-otp-modal-active' : ''}`}>
                    <div className="patientlogin-otp-modal-overlay" onClick={closeModal}></div>
                    <div className="patientlogin-otp-modal-content">
                        <button className="patientlogin-otp-modal-close-btn" onClick={closeModal} aria-label="Close OTP modal">
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                        <h2 className="patientlogin-otp-modal-title">Enter OTP</h2>
                        <p className="patientlogin-otp-modal-instruction">
                            An OTP has been sent to your mobile number: <strong className="patientlogin-otp-phone-highlight">{formData.phone}</strong>.
                        </p>
                        {message && ( 
                             <p className={`patientlogin-message ${
                                message.toLowerCase().includes("error") || 
                                message.toLowerCase().includes("failed") || 
                                message.toLowerCase().includes("invalid") ||
                                message.toLowerCase().includes("enter the 6-digit otp")
                                ? 'patientlogin-message-error' : 'patientlogin-message-success'}`
                            }>{message}</p>
                        )}
                        <input 
                            id="patientlogin-otpInput"
                            type="text" // Changed to text to allow easier maxLength control with custom logic
                            placeholder="Enter 6-digit OTP" 
                            value={otp} 
                            onChange={handleOtpChange} 
                            className="patientlogin-form-input patientlogin-otp-input" 
                            maxLength="6" 
                            autoComplete="one-time-code"
                        />
                        <button onClick={verifyOtp} type='button' className="patientlogin-submit-btn patientlogin-otp-verify-btn">
                            Verify OTP
                        </button>
                          <div className="patientlogin-resend-container">
                            {resendCooldown > 0 ? (
                                <p className="patientlogin-cooldown-text">
                                    Resend OTP in {resendCooldown}s
                                </p>
                            ) : (
                                <button 
                                    onClick={handleResendOtp} 
                                    className="patientlogin-resend-btn"
                                    type="button"
                                >
                                    Resend OTP
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
            
        </div>
    );
};

export default PatientLogin;